eugdpRedirect.$inject = ["$rootScope", "$location"];
import 'bootstrap/js/modal';
angular.module('calendarApp').directive('eugdpRedirect', eugdpRedirect);

function eugdpRedirect($rootScope, $location) {
  return {
    restrict: 'EA',
    replace: true,
    link: function link(scope, elem, attrs) {
      $rootScope.$watch('customerInfo', function () {
        if ($rootScope.customerInfo && !$rootScope.customerInfo.eugdprconsent) {
          $location.path('/account/eugdpr');
        }
      });
    }
  };
}